export default __webpack_public_path__ + "static/media/address.02284495.svg";